import { type LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
  className?: string;
}

export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center min-h-[16rem] text-muted-foreground py-12",
        className,
      )}
      data-testid="empty-state"
    >
      <div className="rounded-full bg-muted p-4 mb-4">
        <Icon className="w-6 h-6 opacity-50" />
      </div>
      <p className="text-base font-medium text-foreground">{title}</p>
      {description && (
        <p className="text-sm mt-1 text-center max-w-xs px-4">{description}</p>
      )}
      {action && (
        <Button
          variant="outline"
          size="sm"
          className="mt-4"
          onClick={action.onClick}
          data-testid="button-empty-state-action"
        >
          {action.label}
        </Button>
      )}
    </div>
  );
}
